const initialState = {
  allPlan: [],
  loading: true,
};

const planReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_PLAN":
      return {
        ...state,
        allPlan: action.data,
        loading: action.loading,
      };
    case "UPDATE_PLAN":
      let plans = state.allPlan;
      let existPlanIndex = plans.findIndex(({ _id }) => action.plan._id == _id);
      existPlanIndex == -1
        ? plans.push(action.plan)
        : (plans[existPlanIndex] = action.plan);
      return {
        ...state,
        allPlan: plans,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export default planReducer;
